import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22sourceSans.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/SourceSans3-Regular.ttf%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/SourceSans3-Italic.ttf%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22../../public/fonts/SourceSans3-Medium.ttf%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/SourceSans3-SemiBold.ttf%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/SourceSans3-SemiBoldItalic.ttf%22,%22weight%22:%22600%22,%22style%22:%22italic%22},{%22path%22:%22../../public/fonts/SourceSans3-Bold.ttf%22,%22weight%22:%22700%22,%22style%22:%22normal%22}]}],%22variableName%22:%22font%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'font', 'font Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
